// extracted by mini-css-extract-plugin
export default {"riskScoreCell":"RiskScoreCell_riskScoreCell__v5Irg","green":"RiskScoreCell_green__SPGFs","red":"RiskScoreCell_red__t8EDk","orange":"RiskScoreCell_orange__rmLFE"};